import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Edit } from "@material-ui/icons";
import axios from "axios";

export default class EditSchemaDetail extends Component {
  constructor(props) {
    super();
    this.state = {
      showEditModal: false,
      hasError: false,
      disableAdd: false,
    };
    this.handleshowEditModal = this.handleshowEditModal.bind(this);
  }

  handleshowEditModal = (e) => {
    this.setState({ showEditModal: !this.state.showEditModal, hasError: false });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableAdd: true });
    axios
      .put("api/basic_schema_edit/" + this.props.schemaDetail.id+"/" + this.props.schemaDetail.bschema_id, this.state)
      .then((res) => {
        this.props.parentCallback(true);
        this.setState({ showEditModal: false, disableAdd: false, });
      })
      .catch((err) => {
        this.setState({ disableAdd: false, hasError: true });
      });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-success btn-sm float-right mr-2"
          title="Edit Schema Detail"
          onClick={this.handleshowEditModal}
        >
          <Edit />
        </button>
        <Modal
          size="md"
          show={this.state.showEditModal}
          onHide={() =>
            this.setState({ showEditModal: !this.state.showEditModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Edit Schema</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div
                  className={
                    this.state.hasError
                      ? "alert alert-danger"
                      : "alert alert-danger d-none"
                  }
                  role="alert"
                >
                  Earning/Deduction Type Already Exist in Schema
                </div>
              </div>
            </div>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Transaction Type</label>
                  <select
                    class="form-control custom-select"
                    required
                    onChange={(e) => this.setState({ ed_id: e.target.value })}
                    defaultValue={this.props.schemaDetail.ed_id}
                  >
                    <option value="">Select Schema</option>
                    {this.props.earningDeductDD.map((ed) => (
                      <option key={ed.id} value={ed.id}>
                        {ed.type} - {ed.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-12 col-sm-12">
                  <label>Pay Period Release</label>
                  <select
                    className="form-control custom-select"
                    required
                    onChange={(e) => {
                      this.setState({ pay_period: e.target.value });
                    }}
                    defaultValue={this.props.schemaDetail.pay_period}
                  >
                    <option value="">Select Pay Period Release</option>
                    <option value="2">15th (Semi-Monthly)</option>
                    <option value="4">30th (Semi-Monthly)</option>
                    <option value="1">15th & 30th (Semi-Monthly)</option>
                    <option value="3">30th (Monthly)</option>
                  </select>
                </div>
              </div>

              <div className="float-right">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                  disabled={this.state.disableAdd}
                >
                  Save
                </button>
                <button
                  onClick={this.handleshowEditModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
